import { render, staticRenderFns } from "./CAPageTwo.vue?vue&type=template&id=6834fd63&"
import script from "./CAPageTwo.vue?vue&type=script&lang=js&"
export * from "./CAPageTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports